import $$ from 'cmn-utils'

const baseUrl = "/api/device/product/event/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
}